import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';
import { WebsiteColumnSelection } from '../WebsiteColumnSelection';
import { StepHeader } from '../StepHeader';
import { getStepStatus, toggleStep } from '../../utils/rankAListHelpers';
import { ColumnInfo, WebsiteColumnResult } from '../../types/rankAList';
import { exampleColumns, exampleWebsiteResults } from '../../data/rankAListExamples';

interface WebsiteColumnStepProps {
  step: number;
  expandedSteps: number[];
  setExpandedSteps: (steps: number[]) => void;
  columns: ColumnInfo[];
  websiteColumnResults: WebsiteColumnResult[];
  onAnalyze: (selectedColumns: string[], searchForMissing: boolean) => void;
}

export const WebsiteColumnStep: React.FC<WebsiteColumnStepProps> = ({
  step,
  expandedSteps,
  setExpandedSteps,
  columns,
  websiteColumnResults,
  onAnalyze
}) => {
  const isOpen = expandedSteps.includes(2);
  
  const getTitle = () => {
    if (step > 2 && websiteColumnResults.length > 0) {
      const columnNames = websiteColumnResults.map(r => r.column).join(', ');
      return (
        <span>
          Select Website Columns: <span className="text-slate-400">{columnNames}</span>
        </span>
      );
    } else if (step < 2) {
      // Show example data when displaying the example
      return (
        <span>
          Select Website Columns: <span className="text-slate-400">website, company_name</span>
        </span>
      );
    }
    return 'Select Website Columns';
  };
  
  return (
    <Collapsible 
      open={isOpen} 
      className="border border-slate-600 rounded-lg bg-slate-800"
    >
      <CollapsibleTrigger asChild>
        <button className="w-full" onClick={() => toggleStep(2, expandedSteps, setExpandedSteps)}>
          <StepHeader 
            stepNumber={2} 
            title={getTitle()} 
            status={getStepStatus(step, 2)}
            isOpen={isOpen}
          />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className="px-4 pb-4">
        <WebsiteColumnSelection 
          columns={step >= 2 ? columns : exampleColumns}
          results={step >= 2 ? websiteColumnResults : exampleWebsiteResults}
          onAnalyze={onAnalyze}
          disabled={step > 2}
        />
      </CollapsibleContent>
    </Collapsible>
  );
}; 